"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbTransaction = void 0;
var tslib_1 = require("tslib");
var amorphic_1 = require("@haventech/amorphic");
var Persistent = /** @class */ (function (_super) {
    tslib_1.__extends(Persistent, _super);
    function Persistent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Persistent;
}((0, amorphic_1.Persistable)(amorphic_1.Supertype)));
var DbTransaction = /** @class */ (function () {
    function DbTransaction() {
    }
    DbTransaction.new = function () {
        return new DbTransaction();
    };
    Object.defineProperty(DbTransaction.prototype, "txn", {
        get: function () {
            return this._txn || this.begin()._txn;
        },
        enumerable: false,
        configurable: true
    });
    DbTransaction.prototype.begin = function () {
        if (!!this._txn) {
            throw new Error('A transaction has already started for this execution; end the transaction by calling `commit` or `reset` before starting another one. If you need a nested transaction, start a new execution and then begin the transaction.');
        }
        this._txn = amorphic_1.amorphicStatic.beginTransaction();
        return this;
    };
    DbTransaction.prototype.merge = function (srcTxn) {
        var _this = this;
        if (srcTxn._txn) {
            Object.keys(srcTxn._txn.dirtyObjects).forEach(function (id) { return _this.setDirty(srcTxn._txn.dirtyObjects[id]); });
            srcTxn._preSaveCallbacks && srcTxn._preSaveCallbacks.forEach(function (cb) { return _this.onPreSave(cb); });
            srcTxn._postSaveCallbacks && srcTxn._postSaveCallbacks.forEach(function (cb) { return _this.onPostSave(cb); });
        }
        return this;
    };
    DbTransaction.prototype.setDirty = function () {
        var _this = this;
        var objs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            objs[_i] = arguments[_i];
        }
        objs.forEach(function (obj) { return obj.persistorSave({ transaction: _this.txn }); });
        return this;
    };
    DbTransaction.prototype.setDelete = function () {
        var _this = this;
        var objs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            objs[_i] = arguments[_i];
        }
        objs.forEach(function (obj) { return obj.setAsDeleted(_this.txn); });
        return this;
    };
    DbTransaction.prototype.onPreSave = function (callback) {
        var callbacks = this._preSaveCallbacks || (this._preSaveCallbacks = []);
        callbacks.push(callback);
        if (callbacks.length === 1) {
            this.txn.preSave = function (txn) { return Promise.all(callbacks.map(function (cb) { return cb(txn); })); };
        }
        return this;
    };
    DbTransaction.prototype.onPostSave = function (callback) {
        var callbacks = this._postSaveCallbacks || (this._postSaveCallbacks = []);
        callbacks.push(callback);
        if (callbacks.length === 1) {
            this.txn.postSave = function (txn, logger, changes, queries) { return Promise.all(callbacks.map(function (cb) { return cb(txn, logger, changes, queries); })); };
        }
        return this;
    };
    DbTransaction.prototype.save = function (obj) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, obj.persistSave(this.txn)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    DbTransaction.prototype.delete = function () {
        var objs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            objs[_i] = arguments[_i];
        }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(objs.map(function (obj) { return obj.persistorDelete({ transaction: _this.txn }); }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    DbTransaction.prototype.commit = function (notifyChanges, notifyQueries) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, amorphic_1.amorphicStatic.commit({ transaction: this.txn, notifyChanges: notifyChanges, notifyQueries: notifyQueries })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.reset()];
                }
            });
        });
    };
    DbTransaction.prototype.reset = function () {
        this._txn = this._preSaveCallbacks = this._postSaveCallbacks = null;
        return this;
    };
    return DbTransaction;
}());
exports.DbTransaction = DbTransaction;
//# sourceMappingURL=DbTransaction.js.map